// The project PO/PM field: a person, picked by typing (PersonaPicker). The
// value is their id (pm_id); onChange(id, name) also hands back the name,
// which the project keeps as po_pm for display. A legacy PM stored only as
// text (no person matched it) is shown as "(custom)" until someone picks a
// person, so it isn't silently lost.
import { useTranslation } from 'react-i18next'
import PersonaPicker from './PersonaPicker'

export default function PMSelect({ value, nombre, members, onChange, className = '' }) {
  const { t } = useTranslation('engineering')
  const legado = value == null && !!nombre
  return (
    <div className={className}>
      <PersonaPicker value={value ?? null} personas={members?.length ? members : undefined}
        placeholder={legado ? `${nombre} ${t('pmSelect.custom')}` : t('pmSelect.unassigned')}
        onChange={(id, p) => onChange(id ?? null, p ? p.name : null)} />
    </div>
  )
}
